import { put, takeLatest } from 'redux-saga/effects'
import { setWorkspace, setStatuses, setMembers, setLoading as setWorkspaceLoading } from '../workspace/workspaceSlice'
import { setProjects, setMemberProjectIds, setLoading as setProjectsLoading } from '../projects/projectsSlice'
import { setLists, setLoading as setListsLoading } from '../lists/listsSlice'
import { setTasks, setLoading as setTasksLoading } from '../tasks/tasksSlice'
import { createDefaults } from './initialStateDefaults'
import { logTiming } from '@/utils/timing'

export const CREATE_INITIAL_STATE = 'initialState/create'
export const createInitialState = () => ({ type: CREATE_INITIAL_STATE })

function* createInitialStateWorker(): Generator<any, void, any> {
    logTiming('[initialState] createInitialStateWorker start')

    const defaults = createDefaults()
    yield put(setWorkspace(defaults.workspace as any))
    yield put(setStatuses(defaults.statuses as any))
    yield put(setMembers(defaults.members as any))
    yield put(setProjects([defaults.project as any]))
    yield put(setMemberProjectIds([defaults.project.id]))
    yield put(setLists([defaults.list as any]))
    yield put(setTasks(defaults.tasks as any))

    yield put(setWorkspaceLoading(false))
    yield put(setProjectsLoading(false))
    yield put(setListsLoading(false))
    yield put(setTasksLoading(false))

    logTiming('[initialState] createInitialStateWorker done')
}

export function* watchInitialStateSaga() {
    yield takeLatest(CREATE_INITIAL_STATE, createInitialStateWorker)
}
